import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DialogService } from 'primeng/dynamicdialog';
import { BookingModel } from '../../../../../models/booking.model';
import { AlertService } from '../../../../../services/alert.service';
import { BookingService } from '../../../../../services/booking.service';
import { CancelBookingDialogComponent } from '../../../../shared-components/cancel-booking-dialog/cancel-booking-dialog.component';

@Component({
  selector: 'app-booking-overview',
  templateUrl: './booking-overview.component.html',
  styleUrl: './booking-overview.component.scss',
  standalone: false,
})
export class BookingOverviewComponent implements OnInit {
  public isLoading = true;
  public billingAddressCollapsed: boolean = false;
  public booking: BookingModel;
  constructor(
    private bookingService: BookingService,
    private activatedRoute: ActivatedRoute,
    private location: Location,
    private alertService: AlertService,
    private dialog: DialogService
  ) {}

  public async ngOnInit(): Promise<void> {
    const bookingId = this.activatedRoute.snapshot.params['bookingId'];
    if (!bookingId) {
      this.location.back();
    }
    await this.getBooking(+atob(bookingId));
    this.isLoading = false;
  }

  public async getBooking(bookingId: number): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.bookingService.getBookingById(bookingId).subscribe({
        next: booking => {
          this.booking = booking;
          resolve();
        },
        error: () => {
          this.alertService.showErrorAlert(
            'Die Buchung konnte nicht geladen werden.'
          );
          this.location.back();
          reject();
        },
      });
    });
  }

  public onConfirmPayment(): void {
    this.isLoading = true;
    this.bookingService.confirmInvoicePayment(this.booking.id).subscribe({
      next: () => {
        this.isLoading = false;
        this.booking.status = 'confirmed';
      },
      error: error => {
        this.isLoading = false;
        console.error('Error confirming payment', error);
        this.alertService.showErrorAlert(
          'Beim Bestätigen der Zahlung ist ein Fehler aufgetreten.'
        );
      },
    });
  }

  public isSeminarInFuture(): boolean {
    return (
      this,
      this.booking.seminarDateSeries.dates.some(date => {
        return new Date(date.startDate) > new Date();
      })
    );
  }

  public cancelBooking(): void {
    const dialogRef = this.dialog.open(CancelBookingDialogComponent, {
      width: '600px',
      data: {
        bookingId: this.booking.id,
        seminarStartDate: new Date(
          this.booking.seminarDateSeries.dates[0].startDate
        ),
        fullPrice: this.booking.discountedPrice,
      },
    });

    dialogRef.onClose.subscribe(result => {
      if (result && result.cancelled) {
        this.booking.status = 'cancelled';
      }
    });
  }

  public onGoBack(): void {
    this.location.back();
  }
}
